/* eslint-disable sort-keys */

export default {
    root: {
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        background: 'radial-gradient(125.46% 125.46% at 50% -6.01%, #FFFFFF 0%, #E9ECF1 32%, #CFD6DE 88%)',
        overflowX: 'hidden',
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column'
    },
    yellowVector: {
        position: 'absolute',
        width: '1440px',
        height: '844.04px',
        top: '77.4px',
        left: '534px',
        opacity: 1,
        zIndex: 0,
        pointerEvents: 'none',
        '@media screen and (max-width: 1722px)': {
            left: '300px',
        },
        '@media screen and (max-width: 1282px)': {
            left: '200px',
            width: '1100px',
            height: 'auto',
        },
    },
    blueVector: {
        position: 'absolute',
        width: '1473.9px',
        height: '844.1px',
        top: '286.58px',
        left: '534px',
        opacity: 1,
        zIndex: 0,
        pointerEvents: 'none',
        '@media screen and (max-width: 1722px)': {
            left: '300px',
        },
        '@media screen and (max-width: 1282px)': {
            left: '200px',
            width: '1100px',
            height: 'auto',
        },
    },
    
    // Header Section
    header: {
        position: 'relative',
        zIndex: 10,
        padding: '50px 88px',
        '@media screen and (max-width: 1282px)': {
            padding: '30px 40px'
        },
        '@media screen and (max-width: 440px)': {
            padding: '20px'
        }
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    rbcLogo: {
        height: '48px',
        width: 'auto',
        '@media screen and (max-width: 1282px)': {
            height: '40px'
        },
        '@media screen and (max-width: 440px)': {
            height: '36px'
        }
    },
    languageButton: {
        '&.MuiButton-root': {
            color: '#003168',
            fontSize: '13.33px',
            fontFamily: 'Roboto',
            fontWeight: 400,
            textTransform: 'uppercase',
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    },
    languageIcon: {
        marginRight: '8px',
        fontSize: '20px',
        color: '#003168'
    },

    // Main Content Section
    mainContent: {
        position: 'relative',
        zIndex: 10,
        boxSizing: 'border-box',
        width: '1650px',
        maxWidth: 'calc(100% - 80px)',
        height: '580px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        '& .MuiGrid-container': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            marginLeft: '0 !important',
            marginTop: '0 !important',
            width: '100% !important',
            justifyContent: 'center',
            alignItems: 'center'
        },
        '@media screen and (min-width: 1920px)': {
            marginTop: '58px'
        },
        // Keep everything in a single row between 1780px and 1920px - just tighten
        // up the spacing so the row fits without wrapping or overflowing.
        '@media screen and (min-width: 1780px) and (max-width: 1920px)': {
            flexWrap: 'nowrap',
            gap: '24px'
        },
        '@media screen and (max-width: 1779px)': {
            width: '1250px',
            height: 'auto',
            flexWrap: 'wrap',
            marginTop: '50px',
        },
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            maxWidth: '834px',
            padding: '0 40px',
            flexDirection: 'column',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '32px',
            height: 'auto',
            '& .MuiGrid-container': {
                flexDirection: 'column',
                flexWrap: 'wrap',
                alignItems: 'center'
            }
        },
        '@media screen and (max-width: 440px)': {
            padding: '0 20px',
            gap: '24px'
        }
    },

    // Left Section - welcomeContainer
    welcomeContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        width: '425px',
        height: '500px',
        flexShrink: 0,
        marginRight: '105px',
        '@media screen and (min-width: 1780px) and (max-width: 1920px)': {
            marginRight: 0
        },
        '@media screen and (max-width: 1282px)': {
            width: '416px',
            maxWidth: '100%',
            height: 'auto',
            gap: '24px',
            margin: '0 auto'
        },
        '@media screen and (max-width: 440px)': {
            width: '401px',
            maxWidth: '100%',
            gap: '20px'
        }
    },

    welcomeText: {
        width: '100%',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        textAlign: 'center',
        color: '#003168',
        '@media screen and (max-width: 1282px)': {
            fontSize: '14px',
            lineHeight: '24px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '13px',
            lineHeight: '22px'
        }
    },
    aagLogoContainer: {
        width: '424px',
        height: '88px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            maxWidth: '100%',
            height: 'auto'
        },
        '@media screen and (max-width: 1282px)': {
            width: '380px',
            height: '70px'
        },
        '@media screen and (max-width: 440px)': {
            width: '100%',
            maxWidth: '280px',
            height: '60px'
        }
    },
    aagNameLogo: {
        fontFamily: 'RBC Display, Roboto, sans-serif',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '52px',
        lineHeight: '70px',
        letterSpacing: '0px',
        textAlign: 'center',
        color: '#003168',
        '@media screen and (max-width: 1919px)': {
            fontSize: '46px',
            lineHeight: '62px'
        },
        '@media screen and (max-width: 1282px)': {
            fontSize: '40px',
            lineHeight: '54px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '34px',
            lineHeight: '46px'
        }
    },
    loginButton: {
        '&.MuiButton-root': {
            width: '400px',
            height: '52px',
            backgroundColor: '#FEDF01',
            borderRadius: '4px',
            color: '#003168',
            fontFamily: 'Roboto',
            fontWeight: 600,
            fontSize: '16px',
            letterSpacing: '0.46px',
            textTransform: 'capitalize',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: '#E5CA01',
                boxShadow: 'none'
            },
            '@media screen and (max-width: 1919px)': {
                width: '380px',
                height: '50px',
                fontSize: '15px'
            },
            '@media screen and (max-width: 1282px)': {
                width: '100%',
                maxWidth: '380px',
                height: '48px',
                fontSize: '15px'
            },
            '@media screen and (max-width: 440px)': {
                maxWidth: '100%',
                height: '44px',
                fontSize: '14px'
            }
        }
    },
    linksContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        width: '230px',
        '@media screen and (max-width: 440px)': {
            width: '100%'
        }
    },
    poweredByText: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        textAlign: 'center',
        color: '#003168'
    },
    digitalMarketplaceText: {
        fontFamily: 'RBC Display, Roboto, sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '25px',
        lineHeight: '100%',
        letterSpacing: '0px',
        textAlign: 'center',
        color: '#003168',
        '@media screen and (max-width: 1282px)': {
            fontSize: '22px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '20px'
        }
    },
    dividerLine: {
        width: '399px',
        height: '0px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        flex: 'none',
        flexGrow: 0,
        '@media screen and (max-width: 1282px)': {
            width: '320px'
        },
        '@media screen and (max-width: 440px)': {
            width: '100%'
        }
    },
    assistanceContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0px',
        gap: '16px',
        width: '399px',
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            maxWidth: '320px'
        },
        '@media screen and (max-width: 440px)': {
            maxWidth: '100%',
            gap: '12px'
        }
    },
    assistanceTitleWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    assistanceTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '135%',
        textAlign: 'center',
        letterSpacing: '0.3%',
        color: '#003168',
        '@media screen and (max-width: 1282px)': {
            fontSize: '15px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '14px'
        }
    },
    assistanceContactWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px'
    },
    assistanceBody: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '175%',
        textAlign: 'center',
        letterSpacing: '0px',
        '@media screen and (max-width: 440px)': {
            fontSize: '13px'
        }
    },
    contactLabel: {
        color: '#60666D'
    },
    contactValue: {
        color: '#0062BF',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    },

    // First Card Wrapper
    firstCardWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '40px',
        '@media screen and (min-width: 1780px) and (max-width: 1920px)': {
            marginRight: 0
        },
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            marginRight: 0,
            justifyContent: 'center'
        }
    },

    // Second Card Wrapper
    secondCardWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        overflow: 'visible',
        // '@media screen and (max-width: 1919px)': {
        //     width: '643px',
        //     height: '365px',
        //     flexBasis: '100%',
        //     justifyContent: 'center',
        //     marginTop: '129px'
        // },
        '@media screen and (max-width: 1282px)': {
            width: '450px',
            height: 'auto',
            justifyContent: 'center',
            marginTop: '60px'
        },
        '@media screen and (max-width: 440px)': {
            width: '382px',
            height: 'auto',
            maxWidth: '100%'
        }
    },

    // Glass Card for second/preview card
    secondCardGlassCard: {
        position: 'relative',
        boxSizing: 'border-box',
        width: '416px',
        height: '513px',
        padding: '40px',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 59.13%, rgba(255, 255, 255, 0.1) 100%)',
        border: '1px solid rgba(229, 229, 229, 0.5)',
        boxShadow: '0px 4px 20px 0px #0000000D',
        backdropFilter: 'blur(15px)',
        borderRadius: '8px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '8px',
            padding: '1px',
            background: 'linear-gradient(146.68deg, #E5E5E5 -0.88%, #47525F 52.98%, #CCCCCC 100.57%)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            pointerEvents: 'none',
            zIndex: -1
        },
        '@media screen and (max-width: 1282px)': {
            width: '450px',
            height: 'auto',
            padding: '20px'
        },
        '@media screen and (max-width: 440px)': {
            width: '382px',
            height: 'auto',
            maxWidth: '100%'
        }
    },

    // Glass Card
    glassCard: {
        position: 'relative',
        boxSizing: 'border-box',
        width: '416px',
        height: '513px',
        padding: '40px 40px 48px',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 59.13%, rgba(255, 255, 255, 0.1) 100%)',
        border: '1px solid rgba(229, 229, 229, 0.5)',
        boxShadow: '0px 4px 20px 0px #0000000D',
        backdropFilter: 'blur(15px)',
        borderRadius: '8px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '8px',
            padding: '1px',
            background: 'linear-gradient(146.68deg, #E5E5E5 -0.88%, #47525F 52.98%, #CCCCCC 100.57%)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            pointerEvents: 'none'
        },
        '@media screen and (max-width: 1919px)': {
            width: '416px',
            height: '513px'
        },
        '@media screen and (max-width: 1722px)': {
            width: '416px',
            height: '513px'
        },
        '@media screen and (max-width: 1282px)': {
            width: '416px',
            height: 'auto',
            padding: '32px'
        },
        '@media screen and (max-width: 440px)': {
            width: '401px',
            height: 'auto',
            maxWidth: '100%',
            padding: '24px'
        }
    },
    cardTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '40px',
        letterSpacing: '-0.5px',
        color: '#003168',
        marginBottom: '8px',
        '@media screen and (max-width: 1722px)': {
            fontSize: '24px',
            lineHeight: '40px'
        },
        '@media screen and (max-width: 1282px)': {
            fontSize: '22px',
            lineHeight: '36px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '20px',
            lineHeight: '32px'
        }
    },
    cardDescription: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        letterSpacing: '0px',
        verticalAlign: 'middle',
        color: '#003168',
        '@media screen and (max-width: 1722px)': {
            fontSize: '16px',
            lineHeight: '28px'
        },
        '@media screen and (max-width: 1282px)': {
            fontSize: '15px',
            lineHeight: '26px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '14px',
            lineHeight: '24px'
        }
    },

    // Laptop Preview Container
    previewContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        zIndex: 2,
    },
    previewMotionWrapper: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    previewDesktop: {
        position: 'absolute',
        width: '599px',
        height: '518px',
        opacity: 1,
        top: '5%',
        left: '-47%',
        maxWidth: 'none',
        objectFit: 'contain',
        filter: 'drop-shadow(0px 24px 40px rgba(0, 0, 0, 0.18))',
        '@media screen and (max-width: 1282px)': {
            display: 'none'
        }
    },
    // Uncut preview image used in column/mobile layout so it never needs to bleed outside its box
    previewMobile: {
        display: 'none',
        '@media screen and (max-width: 1282px)': {
            display: 'block',
            position: 'static',
            width: '100%',
            maxWidth: '380px',
            height: 'auto',
            margin: '0 auto',
            objectFit: 'contain',
            filter: 'drop-shadow(0px 24px 40px rgba(0, 0, 0, 0.18))'
        },
        '@media screen and (max-width: 440px)': {
            maxWidth: '320px'
        }
    },

    // Tagline next to laptop preview
    taglineWrapper: {
        marginTop: '509px',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: '40px',
        whiteSpace: 'nowrap',
        zIndex: 3,
        '@media screen and (min-width: 1780px) and (max-width: 1920px)': {
            marginLeft: 0
        },
        '@media screen and (max-width: 1282px)': {
            position: 'static',
            transform: 'none',
            marginLeft: 0,
            marginTop: '24px',
            alignItems: 'center',
            width: '100%',
            whiteSpace: 'normal'
        }
    },
    taglineText: {
        fontFamily: 'RBC Display, Roboto, sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '30px',
        lineHeight: '40px',
        color: '#0062BF',
        '@media screen and (max-width: 1919px)': {
            textAlign: 'center'
        },
        '@media screen and (max-width: 1282px)': {
            fontSize: '24px',
            lineHeight: '32px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '20px',
            lineHeight: '28px'
        }
    },

    // Footer Section
    footer: {
        position: 'relative',
        zIndex: 10,
        padding: '24px 60px',
        width: '100%',
        boxSizing: 'border-box',
        marginTop: 'auto',
        '@media screen and (max-width: 1282px)': {
            padding: '20px 40px'
        },
        '@media screen and (max-width: 440px)': {
            padding: '16px 20px',
            flexDirection: 'column',
            gap: '12px'
        }
    },
    footerCopyright: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '40px',
        letterSpacing: '0.1px',
        color: '#003168',
        maxWidth: '900px',
        '@media screen and (max-width: 1282px)': {
            fontSize: '13px',
            lineHeight: '24px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '12px',
            lineHeight: '20px',
            textAlign: 'left'
        }
    },
    footerPrivacy: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '40px',
        letterSpacing: '0.1px',
        color: '#003168',
        textAlign: 'right',
        textDecoration: 'underline',
        textDecorationStyle: 'solid',
        '&:hover': {
            color: '#006AC3',
            textDecoration: 'underline'
        },
        '@media screen and (max-width: 1282px)': {
            fontSize: '13px',
            lineHeight: '24px'
        },
        '@media screen and (max-width: 440px)': {
            fontSize: '12px',
            lineHeight: '20px'
        }
    },
    link: {
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        color: '#003168',
        '&:hover': {
            color: '#006AC3'
        }
    },
    descriptionLink: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '16px',
        lineHeight: '28px',
        letterSpacing: '0px',
        verticalAlign: 'middle',
        color: '#006AC3',
        textDecoration: 'underline',
        textDecorationStyle: 'solid',
        '&:hover': {
            color: '#003168',
        }
    }
}
